import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import AppLink from 'ui-forms-components/links/AppLink';
import { getCallsToActionRoute, getCMSRoute } from 'asset-actions-lib-forms/utils/getRoute';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function HubspotTab({
  onClickCMSRoute,
  onClickCTARoute
}) {
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "600",
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.shareDialog.hubspotTab.body"
      })
    }), /*#__PURE__*/_jsx(AppLink
    // @ts-expect-error AppLink accepts this prop but it is not defined in the component's API
    , {
      use: "primary",
      showAsButton: true,
      href: getCMSRoute(),
      onClick: onClickCMSRoute,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.shareDialog.hubspotTab.linkToCMS"
      })
    }), /*#__PURE__*/_jsx(AppLink
    // @ts-expect-error AppLink accepts this prop but it is not defined in the component's API
    , {
      use: "secondary",
      showAsButton: true,
      href: getCallsToActionRoute(),
      onClick: onClickCTARoute,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.shareDialog.hubspotTab.linkToCTAs"
      })
    })]
  });
}